"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreightPalletStatus = void 0;
exports.FreightPalletStatus = {
    AWAITING_ARRIVAL: 'AWAITING_ARRIVAL',
    ARRIVED_AT_CROSSDOCK: 'ARRIVED_AT_CROSSDOCK',
    CANCELLED: 'CANCELLED',
    DISCARDED_DRAFT: 'DISCARDED_DRAFT',
    DRAFT: 'DRAFT',
    MISSING: 'MISSING',
    ARRIVED_AT_CROSSDOCK_WITHOUT_PALLET_LABELS: 'ARRIVED_AT_CROSSDOCK_WITHOUT_PALLET_LABELS'
};
//# sourceMappingURL=freight-pallet-status.js.map